import { render, staticRenderFns } from "./PadoCharSheetAbilityComponent.vue?vue&type=template&id=ed552d8c&scoped=true"
import script from "./PadoCharSheetAbilityComponent.vue?vue&type=script&lang=ts"
export * from "./PadoCharSheetAbilityComponent.vue?vue&type=script&lang=ts"
import style0 from "./PadoCharSheetAbilityComponent.vue?vue&type=style&index=0&id=ed552d8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed552d8c",
  null
  
)

export default component.exports